import React, { useEffect } from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import HeroSection from '../../components/HeroSection/HeroSection'
import Experience from '../../components/Experience/Experience'
import StatusQuo from '../../components/StatusQuo/StatusQuo'
import AllTerrain from '../../components/AllTerrain/AllTerrain'
import BreakingBoundaries from '../../components/BreakingBoundaries/BreakingBoundaries'
import MHEROIntelligent from '../../components/MHEROIntelligent/MHEROIntelligent'
import Crafted from '../../components/Crafted/Crafted'
import RoadStatement from '../../components/RoadStatement/RoadStatement'
import Gallery from '../../components/Gallery/Gallery'
import Tabs from '../../components/Tabs/Tabs'
import VideoSection from '../../components/VideoSection/VideoSection'
import LimitelessUtility from '../../components/LimitelessUtility/LimitelessUtility'
import MhAccessories from '../../components/MhAccessories/MhAccessories'
import Charging from '../../components/Charging/Charging'
import Dimensions from '../../components/Dimensions/Dimensions'
import Links from '../../components/Links/Links'
import Footer from '../../components/Footer.jsx/Footer'


const Home = () => {

  useEffect(() => {
 
  localStorage.removeItem("token");
}, []);
  return (
    <div className="home-page">
     
      <Navbar />
      <HeroSection />
      <Experience/>
      <StatusQuo/>
      <AllTerrain/>
      <BreakingBoundaries/>
      <MHEROIntelligent/>
      <Crafted/>
      <RoadStatement/>
      <Gallery/>
      <Tabs/>
      <VideoSection/>
      <LimitelessUtility/>
      <MhAccessories/>
      <Charging/>
      <Dimensions/>
      <Links/>
      <Footer/>
    </div>
  )
}

export default Home
